import { Component } from 'vue-property-decorator'
import Checkup from '@src/data/checkup'
import { WizardMeasurements } from '@src/routes/members/components/wizard/measurements'
import { MemberProfile } from '@src/data/member-profile'

@Component({
  computed: {
    checkup () {
      return this.$store.state.checkup
    },
    member () {
      return this.$store.state.memberProfile
    }
  }
})
export class MemberWizardMeasurements extends WizardMeasurements {

  member: MemberProfile
  protected checkup: Checkup

  protected loadBodyMeasurements (): any {
    let bodyMeasurements = this.member
    // filter the measurements added to the checkup
    Object.keys(bodyMeasurements.metrics).forEach(type => {
      bodyMeasurements.metrics[type] = bodyMeasurements.metrics[type].filter(measurement => {
        return this.checkup.bodyMeasurementIds.includes(measurement.id)
      })
    })
    this.bodyMeasurements = bodyMeasurements

    this.loading = false
  }
}
